<template>
  <div id="ItemBidding" class="layout-bidding-all">
    <v-card outlined class="mt-4"
      ><v-card-title>Item Bidding </v-card-title
      ><v-card-text>
        <v-data-table
          :headers="headers"
          :items="dataProjectTemplate"
        ></v-data-table></v-card-text
    ></v-card>
  </div>
</template>

<script>
import { _projectservice } from "../../../services/projectservice";
import { numberFormat } from "../../../services/utility";
export default {
  name: "ItemBidding",
  data: () => ({
    dataProjectTemplate: [],
    headers: [
      { text: "Company", value: "companyName" },
      { text: "Short Text", value: "shortDescription" },
      { text: "Long Text", value: "longDescription" },
      { text: "Quantity", value: "quantity" },
      { text: "Unit of Measure", value: "unitOfMeasureName" },
      { text: "Contract Period (Month)", value: "itemPeriod" },
    ],
  }),
  created() {
    this.getProjectTemplate();
  },
  methods: {
    async getProjectTemplate() {
      this.dataProjectTemplate = await _projectservice.GetProjectItem(
        this.$route.params.projectId
      );
    },

    number(number) {
      if (number != null) return numberFormat(number);
    },
  },
};
</script>
<style lang="scss" scoped></style>
